import { render } from "./Layout.vue?vue&type=template&id=219d635d&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=219d635d&lang=less&scoped=true"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219d635d"]])

export default __exports__